<template>
  <div class="tabItem">
    <div class="itemInner minBox">
      <img src="~@/assets/img/aboutUs/companyRoom.png" alt />
      <div class="article aboutSectionTitle">
        <div class="CNtitle">企业简介</div>
        <div class="ENtitle">OUR PROFILE</div>
        <div class="titleLine"></div>
        <div class="textBox">
          <div
            class="textP"
          >杭州凌浩网络科技有限公司成立于2017年，致力于移动互联网的商业模式创新，通过将PC互联网及移动端网络信息整合，应用于艺术品收藏领域，是国内领先的艺术品收藏交流、交易、投资平台。公司开发的艺术收藏网APP通过将艺术资讯、鉴定、在线拍卖、小视频、典当、艺术品经纪人、移动商城、在线支付等功能结合，为艺术家、非物质文化传承人、艺术收藏爱好者、艺术赞助机构、艺术研究机构，构建一个交流、推广、互动的多元化平台。</div>
          <div
            class="textP"
          >企业长期以“弘扬传统文化，传承中华文明”为己任，秉承以人为本、文化兴邦的企业理念，倡导现代文化气息和传统文化艺术属性相融合，以此引领现代都市人的精神文化消费模式，进而影响文化产业市场，发掘中国传统文化内涵及工匠精神，打造以中国传统文化和现代人文属性相融合的新型文化创意产业新格局。</div>
          <div
            class="textP"
          >按照国际现代艺术品的一级市场标准，创新理念，开放合作，并积极协同政府一起打造国内一流的艺术品一级市场。借助互联网、移动终端技术发展线上交易，实现线上与线下的良性互动。深度与文化文物单位馆藏文化资源，博物馆、美术馆、图书馆等单位开展合作，拓展文化创意产品开发投资、设计制作和营销渠道，开发具有艺术性和实用性、适应现代生活需求的艺术衍生品。</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tabItem",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.tabItem {
  width: 100%;
  background: #fff;
  .itemInner {
    height: 830px;
    img {
      width: 640px;
      height: 338px;
      position: absolute;
      top: 80px;
      left: 0;
      z-index: 1;
    }
    .article {
      width: 840px;
      height: 610px;
      background: #f4f4f4;
      position: absolute;
      top: 140px;
      right: 0;
      z-index: 2;
      padding: 56px 60px;
      box-sizing: border-box;
      .textBox {
        padding-top: 8px;
        font-size: 14px;
        line-height: 28px;
        color: #888888;
        letter-spacing: 0;
        .textP {
          margin-top: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/aboutUs/components/tabItem1.vue